<template>
  <div class="pb-100">
    <section class="section section-md">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-md-2">
            <img src="img/theme/promo-1.png" class="img-fluid floating" />
          </div>
          <div class="col-md-6 order-md-1">
            <div class="pr-md-5">
              <icon
                name="ni ni-settings-gear-65"
                class="mb-5"
                size="lg"
                type="success"
                shadow
                rounded
              ></icon>
              <h3>關於我們</h3>
              <span>
              傲卓集團科技有限公司乃傲卓集團有限公司旗下的研發及開拓純天然產品的子公司，本公司宗旨為致力研發及引入各地以純天然成分的產品作為在香港或以外地方推廣
              <hr>
              其中本公司主力推廣之產品糸列<b> DREGLE ELEMENTS </b>在過去十五年間一直透過其研發中心的努力，結合了日本及台灣專家的合作，憑著研究的熱誠，以天然與科學精粹，依照人體肌膚的生理改變與特征，著重以全天然，低敏，低刺激之理念，不斷測試、改進及臨床，證實了具活性礦物生態水源配合電氣石及精煉的生產技術的微妙關系而釋放出的負離子和遠紅外線波動能量對無藥療效的一個大突破，在皮膚護理修覆方面有著卓越的功效。本公司獨有的微導肌體滲透技術，是現時滲透至皮層最高的方法，可以被皮膚完全吸收，促進基底層細胞深層滋養，令肌膚恢覆細嫩。本公司所有產品均全采用 <b>純天然成分，不含添加色素、化學香精、防腐劑及藥物</b>。
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- <section class="section section-lg pt-0">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div class="col-12 col-lg-3">
                <card class="border-0" hover shadow body-classes="py-4">
                  <h6 class="text-primary text-uppercase pb-2 font-weight-bold">E WATER <br />試紙PH值測試</h6>
                  <img src="https://www.orchard-biotech.com/image/catalog/product/415212015.jpg" alt="" class="img-fluid">
                </card>
              </div>
              <div class="col-12 col-lg-3">
                <card class="border-0" hover shadow body-classes="py-4">
                  <h6 class="text-success text-uppercase pb-2 font-weight-bold">E WATER <br />抗氧化還原力測試</h6>
                  <img src="https://www.orchard-biotech.com/image/catalog/product/659773820.jpg" alt="" class="img-fluid">
                </card>
              </div>
              <div class="col-12 col-lg-3">
                <card class="border-0" hover shadow body-classes="py-4">
                  <h6 class="text-warning text-uppercase pb-2 font-weight-bold">E WATER<br />滲透力測試</h6>
                  <img src="https://www.orchard-biotech.com/image/catalog/product/815782521.jpg" alt="" class="img-fluid">
                </card>
              </div>
              <div class="col-12 col-lg-3">
                <card class="border-0" hover shadow body-classes="py-4">
                  <h6 class="text-primary text-uppercase pb-2 font-weight-bold">E WATER<br /> 電位MV值測試</h6>
                  <img src="https://www.orchard-biotech.com/image/catalog/product/1061214354.jpg" alt="" class="img-fluid">
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script>
export default {};
</script>